import { Flex } from 'antd';
import { useEffect } from 'react';
import { useState } from 'react';

const Clock = () => {
    const [currentDateTime, setCurrentDateTime] = useState(new Date());

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentDateTime(new Date());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const formatTime = (date) => {
        return date.toLocaleTimeString('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
        });
    };

    const getCurrentDate = () => {
        return currentDateTime
            .toLocaleDateString('en-GB', {
                weekday: 'short',
                day: 'numeric',
                month: 'short'
            })
            .replace(',', '')
            .replace('.', '');
    };

    return (
        <Flex vertical style={{ textAlign: 'center', minWidth: '70px' }}>
            <span style={{ color: 'white', fontSize: 14 }}>{formatTime(currentDateTime)}</span>
            <span style={{ color: 'white', fontSize: 13 }}>{getCurrentDate()}</span>
        </Flex>
    );
};

export default Clock;
